import { render, staticRenderFns } from "./SuspensionCareTable.vue?vue&type=template&id=0c8546ca&scoped=true"
import script from "./SuspensionCareTable.vue?vue&type=script&lang=js"
export * from "./SuspensionCareTable.vue?vue&type=script&lang=js"
import style0 from "./SuspensionCareTable.vue?vue&type=style&index=0&id=0c8546ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8546ca",
  null
  
)

export default component.exports